import BaseModel from "./BaseModel";

export default class EstimateStatus extends BaseModel {

	static entity = 'estimate_statuses';
	static route = 'estimate-statuses';
	static plural = 'estimate_statuses';
	static singular = 'estimate_status';

	static fields () {
		return {
			id: this.attr(null),
			name: this.attr(null),
			position: this.attr(null),
			created_at: this.attr(null), 
			updated_at: this.attr(null), 
			deleted_at: this.attr(null)
		}
	}

	get getVariant() {
		switch(this.name) {
			case 'Draft':
				return 'warning';
			case 'Cancelled':
				return 'danger';
			case 'Sent':
				return 'info';
			case 'Declined':
				return 'danger';
			case 'Approved':
				return 'success';
		}
		return 'default';
	}

}
